export default "__VITE_ASSET__PmLwtUkD__"